
/**
 * 给整个页面添加背景水印
 * <div v-water="{ text: '添加水印', textColor: 'rgba(0, 0, 0, 0.4)' }"></div>
 * @param str 
 * @param parentNode 
 * @param font 
 * @param textColor 
 */
const waterMarker = (str, parentNode, font, textColor) => {
    let can             = document.createElement("canvas");
    parentNode.appendChild(can);
    can.width           = 205;
    can.height          = 140;
    can.style.display   = "none";
    let cans            = can.getContext("2d");
    cans.rotate((-20 * Math.PI) / 180);
    cans.font           = font || "16px Microsoft JhengHei";
    cans.fillStyle      = textColor || "rgba(0, 0, 0, 0.3)";
    cans.textAlign      = "left";
    cans.textBaseline   = "Middle";
    cans.fillText(str, can.width / 10, can.height / 2);
    parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
}

export default {
    mounted(el, binding) {
        waterMarker(binding.value.text, el, binding.value.font, binding.value.textColor);
    }
};